import React, { useEffect, useState } from "react"
import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  Input,
  Label,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import "../../../assets/css/Finance/Style/TDS/style.css"
import AddImg from "../../../assets/images/Inventory/addImg.jpg"
import ViewImg from "../../../assets/images/Inventory/viewImg.jpg"
import AssignImg from "../../../assets/images/Inventory/AssignImg.jpg"
import ReactSelect from "react-select"
import "../../../assets/css/Finance/Style/InventoryPage.css"

import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
// import InfoGif from "../../../assets/images/GIF/question-mark.gif"

// common component
import Pagination from "components/Common/Pagination"

// components
// import ViewProfile from "./ViewIntroducer/ViewProfile"
// import ViewActivity from "./ViewIntroducer/ViewActivity"
// import ViewNotes from "./ViewIntroducer/ViewNotes"

// Hover card
import ProfileDetails from "components/Common/ProfileDetails"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
// import ViewFiles from "./ViewIntroducer/ViewFiles"
// import ViewPayment from "./ViewIntroducer/ViewPayment"
import configure from "configure"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import indiaFlag from "../../../assets/images/flags/uk.png"
import ukFlag from "../../../assets/images/flags/india.png"
import NewPagination from "components/Common/Newpagination"
import Select from "react-select"
import warningImg from "../../../assets/images/Inventory/warningImg.jpg"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import moment from "moment"
import { colourStyles } from "utils/common-options"

const ModalTable = ({ isOpen, toggle, data, columns, title }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setGlobalFilter,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      centered
      style={{ maxWidth: "95vw", width: "95vw" }}
    >
      <ModalHeader toggle={toggle} className="text-purple">
        <div className="d-flex align-items-center justify-content-between w-100">
          <span className="fw-bold">{title}</span>

          <a className="d-flex gap-2 align-items-center general-box mb-0 ml-10">
            <h5 className="text-purple mb-0">Name:</h5>
            <h5 className="text-primary mb-0">{data[0]?.inventoryInfo?.inventory_name}</h5>
          </a>
        </div>
      </ModalHeader>
      <ModalBody>
        <Row className="mb-2">
          <Col>
            <select
              className="border-radius form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={e => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40, 50].map(size => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </Col>
          <Col md={8} className="d-flex justify-content-end">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor={`search-bar-${title}`} className="search-label">
                  <span id={`search-bar-${title}-label`} className="sr-only">
                    Search this table
                  </span>
                  <input
                    id={`search-bar-${title}`}
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder="Search..."
                    value={globalFilter || ""}
                    onChange={e => setGlobalFilter(e.target.value)}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </Col>
        </Row>

        <Table bordered hover responsive striped {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row)
                return (
                  <tr key={i} {...row.getRowProps()}>
                    {row.cells.map((cell, index) => (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No {title} Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination */}
        <Row className="justify-content-md-end justify-content-center align-items-center mt-3">
          <NewPagination
            gotoPage={gotoPage}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            page={page}
            data={data}
            previousPage={previousPage}
            nextPage={nextPage}
          />
        </Row>
      </ModalBody>
    </Modal>
  )
}

function TableContainer({ columns, data, setAddInventory }) {
  const [fixedContent, setFixedContent] = useState(false)
  const [formPopup, setFormPopup] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  document.addEventListener("keydown", e => {
    if (e.key == "Escape") {
      setFormPopup(false)
    }
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const excelColumns = []
  columns.forEach(column => {
    column.Header !== "Action" && excelColumns.push(column.Header)
  })
  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(10), [])

  const [title, setTitle] = useState("")
  const [name_modal, setNameModal] = useState(false)

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-2">
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className=" btn btn-save btn-label"
              onClick={() => setAddInventory(true)}
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Add
              Inventory
            </a>
          </div>
        </Col>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fix-header" : ""
            } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      ></a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const Inventory = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [addInventory, setAddInventory] = useState(false)
  const [assignInventory, setAssignInventory] = useState(false)
  const [quickInv, setQuickInv] = useState(false)
  const [deletePopup, setDeletePopup] = useState(false)
  const [inveIdPopup, setInveIdPopup] = useState(false)
  const [warrantyPopup, setWarrantyPopup] = useState("")
  const [repairPopup, setRepairPopup] = useState(false)
  const [discardPopup, setDiscardPopup] = useState(false)
  const [quickInvId, setQuickInvId] = useState(null)

  // ---------- Add these states ----------
  const [category, setCategory] = useState(null)
  const [subcategory, setSubcategory] = useState(null)
  const [inventItem, setInventItem] = useState(null)
  const [purchaseDate, setPurchaseDate] = useState("")
  const [warranty, setWarranty] = useState("")
  const [expense, setExpense] = useState(null)

  // New-expense fields (only used when type = new)
  const [locationValue, setLocationValue] = useState(null)
  const [currencyValue, setCurrencyValue] = useState(null)
  const [paymentViaValue, setPaymentViaValue] = useState(null)
  const [expenseCategoryValue, setExpenseCategoryValue] = useState(null)
  const [titleValue, setTitleValue] = useState("")
  const [amountValue, setAmountValue] = useState("")
  const [gstValue, setGstValue] = useState("")
  const [uploadedFile, setUploadedFile] = useState(null)
  const [introducerValue, setIntroducerValue] = useState(null)
  const [chargeIntroducer, setChargeIntroducer] = useState(0)
  const [paymentDate, setPaymentDate] = useState("latest")
  const [inventoryItem, setInventoryItem] = useState("")
  const [inventoryQuantity, setInventoryQuantity] = useState("")
  const [inventoryPurchaseDate, setInventoryPurchaseDate] = useState("")

  const [selectedInventoryId, setSelectedInventoryId] = useState(null)

  const resetAddForm = () => {
    setCategory(null)
    setSubcategory(null)
    setInventItem(null)
    setQuantity(null)
    setPurchaseDate("")
    setWarranty("")
    setSelectedType("")
    setExpense(null)
    setLocationValue(null)
    setCurrencyValue(null)
    setPaymentViaValue(null)
    setExpenseCategoryValue(null)
    setTitleValue("")
    setAmountValue("")
    setGstValue("")
    setUploadedFile(null)
    setIntroducer(0)
    setIntroducerValue(null)
    setChargeIntroducer(0)
    setPayPaymentCurrency(null)
    setPayPaymentAmount("")
    setConvertInrAmountPay("")
  }

  const handleAddInventory = async e => {
    e.preventDefault()
    // ---------- Basic validation ----------
    if (
      !category ||
      !subcategory ||
      !inventItem ||
      !quantity ||
      !purchaseDate ||
      !selectedType
    ) {
      Swal.fire({
        icon: "warning",
        text: "Please fill all required inventory fields.",
      })
      return
    }

    // ---------- Build inventory payload ----------
    const payload = {
      category: category,
      subCategory: subcategory,
      inventory_item: inventItem,
      quantity,
      purchase_date: purchaseDate,
      warranty: warranty,
      expense: selectedType,
    }

    const token = secureLocalStorage.getItem("auth_token")

    // Existing expense?
    if (selectedType === "existing") {
      if (!expense) {
        Swal.fire({ icon: "warning", text: "Select an existing expense." })
        return
      }
      payload.expense_id = expense
    }

    // New expense?
    if (selectedType === "new") {
      if (
        !locationValue ||
        !currencyValue ||
        !paymentViaValue ||
        !expenseCategoryValue ||
        !titleValue ||
        !amountValue
      ) {
        Swal.fire({
          icon: "warning",
          text: "Fill all required new-expense fields.",
        })
        return
      }

      // Build new expense data
      const newExpenseData = {
        type: 2,
        location: locationValue.value,
        currency: currencyValue.value,
        payment_via: paymentViaValue.value,
        category: expenseCategoryValue.value,
        title: titleValue,
        amount: amountValue,
        gst: gstValue || null,
        currency_rate: convertInrAmountPay || "1",
        introducer: introducer,
        introducer_id: introducerValue ? introducerValue.value : null,
        charge_introducer: chargeIntroducer,
        date: purchaseDate,
        recordPayment: 0,
      }

      // Use FormData for new expense (handles file upload)
      const formData = new FormData()
      for (const key in newExpenseData) {
        formData.append(key, newExpenseData[key])
      }
      if (uploadedFile) {
        formData.append("file", uploadedFile)
      }

      try {
        toggleLoading(true)
        const expenseResponse = await axios({
          method: "post",
          url: `${configure.nodeApi}/addBudgetExpense`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        console.log("expenseResponse: ", expenseResponse.data.data.expense)

        if (
          expenseResponse.data &&
          (expenseResponse.data.success || expenseResponse.success)
        ) {
          // Extract new expense ID (adjust path based on actual response structure, e.g., expenseResponse.data.data.id)
          const newExpenseId =
            expenseResponse.data.data.expense ||
            expenseResponse.data.data.expense
          const expenses = expenseResponse.data.data.expense || []
          console.log("expenses: ", expenses)
          if (expenses.length > 0) {
            console.log("Last expense:", expenses[expenses.length - 1])
          } else {
            console.log("No expenses found")
          }
          if (!newExpenseId) {
            throw new Error("No expense ID returned from creation API.")
          }
          payload.expense_type = "existing"
          payload.expense_id = expenses[expenses.length - 1].id
        } else {
          Swal.fire({
            icon: "error",
            text:
              expenseResponse.data?.message || "Failed to create new expense.",
          })
          return
        }
      } catch (err) {
        console.error("Expense creation error:", err)
        Swal.fire({
          icon: "error",
          text: err.message || "Error creating new expense.",
        })
        return
      } finally {
        toggleLoading(false)
      }
    }

    // ---------- API call for inventory ----------
    try {
      toggleLoading(true)
      console.log("Inventory payload: ", payload)
      const response = await FetchNodePostData(
        toggleLoading,
        "inventory/addInventory",
        token,
        payload
      )

      if (response.success || response.data?.success) {
        Swal.fire({ icon: "success", text: "Inventory added successfully!" })
        setAddInventory(false)
        resetAddForm() // clear UI
        fetchData() // refresh table
      } else {
        Swal.fire({
          icon: "error",
          text: response.message || "Failed to add inventory.",
        })
      }
    } catch (err) {
      console.error(err)
      Swal.fire({
        icon: "error",
        text: err.message || "Network / server error.",
      })
    } finally {
      toggleLoading(false)
    }
  }

  const handleAdditionalInventory = async e => {
    e.preventDefault()
    // ---------- Basic validation ----------
    if (!quantity || !purchaseDate || !warranty || !selectedType) {
      Swal.fire({
        icon: "warning",
        text: "Please fill all required inventory fields.",
      })
      return
    }

    // ---------- Build inventory payload ----------
    const payload = {
      id: quickInvId,
      quantity,
      purchase_date: purchaseDate,
      warranty: warranty,
    }

    const token = secureLocalStorage.getItem("auth_token")

    // Existing expense?
    if (selectedType === "existing") {
      if (!expense) {
        Swal.fire({ icon: "warning", text: "Select an existing expense." })
        return
      }
      payload.expense_id = expense
    }

    // New expense?
    if (selectedType === "new") {
      if (
        !locationValue ||
        !currencyValue ||
        !paymentViaValue ||
        !expenseCategoryValue ||
        !titleValue ||
        !amountValue
      ) {
        Swal.fire({
          icon: "warning",
          text: "Fill all required new-expense fields.",
        })
        return
      }

      // Build new expense data
      const newExpenseData = {
        type: 2,
        location: locationValue.value,
        currency: currencyValue.value,
        payment_via: paymentViaValue.value,
        category: expenseCategoryValue.value,
        title: titleValue,
        amount: amountValue,
        gst: gstValue || null,
        currency_rate: convertInrAmountPay || "1",
        introducer: introducer,
        introducer_id: introducerValue ? introducerValue.value : null,
        charge_introducer: chargeIntroducer,
        date: purchaseDate,
        recordPayment: 0,
      }

      // Use FormData for new expense (handles file upload)
      const formData = new FormData()
      for (const key in newExpenseData) {
        formData.append(key, newExpenseData[key])
      }
      if (uploadedFile) {
        formData.append("file", uploadedFile)
      }

      try {
        toggleLoading(true)
        const expenseResponse = await axios({
          method: "post",
          url: `${configure.nodeApi}/addBudgetExpense`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        console.log("expenseResponse: ", expenseResponse.data.data.expense)

        if (
          expenseResponse.data &&
          (expenseResponse.data.success || expenseResponse.success)
        ) {
          // Extract new expense ID (adjust path based on actual response structure, e.g., expenseResponse.data.data.id)
          const newExpenseId =
            expenseResponse.data.data.expense ||
            expenseResponse.data.data.expense
          const expenses = expenseResponse.data.data.expense || []
          console.log("expenses: ", expenses)
          if (expenses.length > 0) {
            console.log("Last expense:", expenses[expenses.length - 1])
          } else {
            console.log("No expenses found")
          }
          if (!newExpenseId) {
            throw new Error("No expense ID returned from creation API.")
          }
          payload.expense_type = "existing"
          payload.expense_id = expenses[expenses.length - 1].id
        } else {
          Swal.fire({
            icon: "error",
            text:
              expenseResponse.data?.message || "Failed to create new expense.",
          })
          return
        }
      } catch (err) {
        console.error("Expense creation error:", err)
        Swal.fire({
          icon: "error",
          text: err.message || "Error creating new expense.",
        })
        return
      } finally {
        toggleLoading(false)
      }
    }

    // ---------- API call for inventory ----------
    try {
      toggleLoading(true)
      console.log("Inventory payload: ", payload)
      const response = await FetchNodePostData(
        toggleLoading,
        "inventory/additionalInventory",
        token,
        payload
      )

      if (response.success || response.data?.success) {
        Swal.fire({ icon: "success", text: "Inventory added successfully!" })
        setAddInventory(false)
        resetAddForm() // clear UI
        fetchData() // refresh table
      } else {
        Swal.fire({
          icon: "error",
          text: response.message || "Failed to add inventory.",
        })
      }
    } catch (err) {
      console.error(err)
      Swal.fire({
        icon: "error",
        text: err.message || "Network / server error.",
      })
    } finally {
      toggleLoading(false)
    }
  }

  const handleSelectChange = selectedOption => {
    setSelectedInventoryId(selectedOption ? selectedOption.value : null)
  }

  document.addEventListener("keydown", e => {
    if (e.key == "Escape") {
      setAddInventory(false)
      setAssignInventory(false)
      setQuickInv(false)
      setQuickInv(false)
      setDeletePopup(false)
      setInveIdPopup(false)
      setWarrantyPopup(false)
      setRepairPopup(false)
      setDiscardPopup(false)
    }
  })

  const [boxWidth, setBoxWidth] = useState(0)

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth
      setBoxWidth(viewportWidth * 0.25)
    }
    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setmodal_fullscreen(false)
  })

  //meta title
  document.title = "Inventory | Zithas Crm"

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setmodal_fullscreen(false)
  })

  const [modal_Access, setAccessDenied] = useState(false)
  const [inventoryLogData, setInventoryLogData] = useState([])

  const onDelete = async id => {
    console.log("Delete function called: ", id)
    const result = await Swal.fire({
      icon: "warning",
      text: "Are you sure you want to delete this inventory?",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    })

    if (result.isConfirmed) {
      try {
        const response = await FetchNodeDeleteData(
          toggleLoading,
          `inventory/deleteInventory`,
          id
        )

        console.log("Delete response:", response)

        if (response.success || response.data?.success) {
          Swal.fire({
            icon: "success",
            text: "Inventory deleted successfully!",
            confirmButtonText: "OK",
          })
          fetchData()
        } else {
          Swal.fire({
            icon: "error",
            text: response.message || "Failed to delete inventory.",
          })
        }
      } catch (error) {
        console.error("Error deleting inventory:", error)
        Swal.fire({
          icon: "error",
          text: "An error occurred while deleting inventory.",
        })
      }
    }
  }

  const handleViewLogs = async id => {
    const response = await fetchNodeData(
      toggleLoading,
      `inventory/getInventoryLogs/${id}`,
      secureLocalStorage.getItem("auth_token")
    )
    console.log("logs: ", response)
    setViewModal(true)
    if (response.success || response.data.success) {
      setInventoryLogData(response.data)
    } else {
      setViewModal(true)
    }
  }

  const [assigneeitemsId, setAssigneeitemsId] = useState(null)
  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "id",
        className: "fi_id",
      },
      {
        Header: "Inventory Item",
        accessor: "inventory_item_details.inventory_name",
        className: "fi_name",
      },
      {
        Header: "Total Quantity",
        accessor: "quantity",
        className: "fi_quantity",
      },
      {
        Header: "Balance Quantity",
        accessor: "balanceQuantity",
        className: "fi_quantity",
      },
      {
        Header: "Total Expense",
        accessor: "expenseAmount",
        className: "fi_expense",
      },
      {
        Header: "Purchase Date",
        accessor: "purchase_date",
        className: "fi_purchase_date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MM-YYYY") : "-"),
      },

      {
        Header: "Action",
        accessor: "action",
        className: "fi_action text-center",
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center">
              {/* Assign Inventory Button */}
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => {
                  console.log(
                    "cellProps: ",
                    cellProps.row.original.inventory_item_details.inventory_name
                  )
                  setInventoryItem(
                    cellProps.row.original.inventory_item_details.inventory_name
                  )
                  setInventoryQuantity(cellProps.row.original.quantity)
                  setInventoryPurchaseDate(cellProps.row.original.purchase_date)

                  console.log("Inventory Item: ", inventoryItem)
                  console.log("Inventory Quantity: ", inventoryQuantity)

                  setAssigneeitemsId(cellProps.row.original.id)
                  fetchItemsOptions(cellProps.row.original.id)
                  fetchStaffOptions()

                  setAssignInventory(true)
                }}
                title="Assign Inventory"
              >
                <i className="bi bi-people-fill"></i>
              </button>

              {/* Add Inventory Button */}
              <button
                onClick={() => {
                  setQuickInvId(cellProps.row.original.id)
                  setQuickInv(true)
                }}
                title="Add Inventory"
                className="btn btn-sm btn-outline-secondary mx-2"
              >
                <i className="fas fa-plus"></i>
              </button>

              {/* Dropdown Menu */}
              <UncontrolledDropdown
                className="dropdown"
                style={{ width: "29px" }}
              >
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>

                <DropdownMenu className="dropdown-menu-end">
                  {/* View Inventory Logs */}
                  <a
                    onClick={() => handleViewLogs(cellProps.row.original.id)}
                    className="dropdown-item"
                    title="View Inventory Logs"
                  >
                    <i className="fas fa-history pr-10 text-primary"></i> View
                    Logs
                  </a>

                  {/* Delete Inventory */}
                  <a
                    onClick={() => onDelete(cellProps.row.original.id)}
                    className="dropdown-item"
                    title="Delete Inventory"
                  >
                    <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
                    Delete
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ],
    []
  )

  const data2 = [
    {
      id: 1,
      inventory_name: "Computer System",
      quantity: 15,
      total_expense: "50,000",
      purchase_date: "04/11/2024",
    },
    {
      id: 2,
      inventory_name: "Electric Equipment",
      quantity: 10,
      total_expense: "25,000",
      purchase_date: "04/11/2024",
    },
    {
      id: 3,
      inventory_name: "Computer System",
      quantity: 25,
      total_expense: "75,000",
      purchase_date: "04/11/2024",
    },
    {
      id: 4,
      inventory_name: "Electric Equipment",
      quantity: 18,
      total_expense: "90,000",
      purchase_date: "04/11/2024",
    },
  ]
  const [data, setData] = useState([])

  const fetchData = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      "inventory/getInventory",
      secureLocalStorage.getItem("auth_token")
    )
    console.log(response)
    if (response.success || response.data.success) {
      setData(response.inventory || response.data.inventory)
    } else {
      setData([])
    }
  }

  const [selectedType, setSelectedType] = useState("")
  const Assigneeoptions = [
    { label: "Select Assignee", value: "Select Assignee" },
    { label: "Rahul Ovhal", value: "Rahul Ovhal" },
    { label: "Zain Marchawala", value: "Zain Marchawala" },
    { label: "Janvi Bhagat", value: "Janvi Bhagat" },
  ]
  const warrantyOptions = [
    { label: "30 Days", value: "30" },
    { label: "60  Days", value: "60" },
    { label: "90  Days", value: "90" },
    { label: "180  Days", value: "180" },
    { label: "360  Days", value: "360" },
  ]

  const inventoryIdOptions = [
    { label: "Mo-2125", value: "Mo-2125" },
    { label: "Mo-452", value: "Mo-452" },
    { label: "Mo-782", value: "Mo-782" },
    { label: "Mo-8656", value: "Mo-8656" },
    { label: "Mo-7545", value: "Mo-7545" },
    { label: "Mo-6232", value: "Mo-6232" },
    { label: "Mo-4121", value: "Mo-4121" },
    { label: "Mo-1241", value: "Mo-1241" },
    { label: "Mo-3625", value: "Mo-3625" },
  ]
  const [itemsOptions, setItemsOptions] = useState([])
  const [allStaffDatas, setAllStaffDatas] = useState([])

  const fetchItemsOptions = async inventoryId => {
    const response = await fetchNodeData(
      toggleLoading,
      `inventory/unassignedItems/${inventoryId}`,
      secureLocalStorage.getItem("auth_token")
    )
    console.log("items response: ", response)
    if (response.success || response.data.success) {
      setItemsOptions(response.data || [])
    } else {
      setItemsOptions([])
    }
  }

  const fetchStaffOptions = async () => {
    toggleLoading(true)
    try {
      const bearerToken = secureLocalStorage.getItem("auth_token")
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/staff`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(response => {
        const allStaffOption = response.data.data.map(obj => {
          return {
            label: obj?.alias_name,
            value: obj.id,
            ...obj,
          }
        })

        setAllStaffDatas(allStaffOption)
        toggleLoading(false)
      })
    } catch (err) {
      console.log(err)
      toggleLoading(false)
    }
  }
  const toggleLoading = loading => {
    setLoading(loading)
  }

  const [location, setLocation] = useState([])
  const [Categories, setCategories] = useState([])
  const [payments, setPayments] = useState([])
  const [Currency, setCurrency] = useState([])
  const [subcategoryOptions, setSubcategoryOptions] = useState([])
  const [allSubcategoryOptions, setAllSubcategoryOptions] = useState([])
  const [CategoryOptions, setCategoryOptions] = useState([])  
  const [ItemOptions, setInventoryItemOptions] = useState([])
  const [introducerOptions, setIntroducerOptions] = useState([])
  const [payPaymentCurrency, setPayPaymentCurrency] = useState(null) // selected currency { label, value }
  const [payPaymentAmount, setPayPaymentAmount] = useState("") // amount entered
  const [convertInrAmountPay, setConvertInrAmountPay] = useState("") // converted INR amount
  const [isConvertedAmountPay, setIsConvertedAmountPay] = useState(false)

  const fetchExpenseOptions = async () => {
    toggleLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/expenseData`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${secureLocalStorage.getItem("auth_token")}`
        },
      })
      if (response) {
        const modifyLocation = response?.data?.data?.location?.map(items => {
          return {
            label: items.location,
            value: items.id,
          }
        })
        const modifyCategories = response?.data?.data?.expense_category?.map(
          items => {
            return {
              label: items.categoryname,
              value: items.id,
            }
          }
        )
        const modifyModes = response?.data?.data?.modes?.map(items => {
          const labelD =
            items.payment_via == 1
              ? "Bank Account"
              : items.payment_via == 2
              ? "Credit Card"
              : items.payment_via == 3
              ? "Others"
              : ""
          return {
            label: items.payment_mode,
            value: items.id,
            payment_via: items.payment_via,
          }
        })
        const modifyCurrency = response?.data?.data?.currency?.map(items => {
          return {
            label: items.currency,
            value: items.id,
          }
        })

        setCurrency(modifyCurrency)
        setPayments(modifyModes)
        setLocation(modifyLocation)
        setCategories(modifyCategories)
        toggleLoading(false)
      }
    } catch (err) {
      console.log(err)
      toggleLoading(false)
    }
  }
  const ExpenseData = async () => {
    console.log("calling expense data")
    const ExpenseData = await fetchNodeData(
      toggleLoading,
      "inventory/expense",
      secureLocalStorage.getItem("auth_token")
    )
    console.log("expenseData: ", ExpenseData)
    if (ExpenseData.success || ExpenseData.data.success) {
      setExpenseOptions(ExpenseData.data)
    } else {
      setExpenseOptions([])
    }
  }
  const fetchInventoryOptions = async () => {
    toggleLoading(true)
    console.log(`called`)
    const response = await fetchNodeData(
      toggleLoading,
      "inventorySettings/options",
      secureLocalStorage.getItem("auth_token")
    )
    console.log("response: ", response)
    if (response.success) {
      setCategoryOptions(response.data.category)
      setSubcategoryOptions(response.data.subcategory)
      setAllSubcategoryOptions(response.data.subcategory)
      setInventoryItemOptions(response.data.inventory)
    } else {
      setCategoryOptions([])
      setSubcategoryOptions([])
      setInventoryItemOptions([])
    }
    toggleLoading(false)
  }
  const fetchIntroducers = async () => {
    try {
      toggleLoading(true)
      const data = await fetchNodeData(
        toggleLoading,
        "introducerOptions/0",
        secureLocalStorage.getItem("auth_token")
      )
      if (data.status && data.introducers) {
        const options = data.introducers.map(introducer => ({
          value: introducer.id,
          label: introducer.company,
        }))
        setIntroducerOptions(options)
      }
    } catch (error) {
      console.error("Error fetching introducers:", error)
      Swal.fire({
        icon: "error",
        text: `Failed to fetch introducers: ${error.message}`,
      })
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    ExpenseData()
    fetchExpenseOptions()
    fetchInventoryOptions()
    fetchIntroducers()
    fetchData()
  }, [])

  useEffect(() => {
    if (payPaymentCurrency && payPaymentAmount) {
      if (payPaymentCurrency.label !== "INR") {
        const fetchCurrencyRate = async () => {
          setLoading(true)
          try {
            const response = await axios.get(
              `https://api.frankfurter.dev/v1/${paymentDate}?from=${payPaymentCurrency.label}&to=INR`
            )
            setLoading(false)
            const rate = response.data.rates.INR
            const { value } = await Swal.fire({
              title: "Exchange Rate Fetched",
              html: `<b>1 ${payPaymentCurrency.label} = ${rate.toFixed(2)} INR</b><br/><small>Confirm or enter a different rate.</small>`,
              input: "text",
              inputValue: rate.toFixed(2),
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: "Confirm",
              inputValidator: val => {
                if (!val || isNaN(val) || Number(val) <= 0) return "Please enter a valid exchange rate."
              },
            })
            if (value) setConvertInrAmountPay(value)
          } catch (error) {
            setLoading(false)
            const { value } = await Swal.fire({
              title: "Exchange Rate Not Available",
              text: `Could not fetch rate for ${payPaymentCurrency.label}. Please enter it manually.`,
              input: "text",
              inputPlaceholder: `1 ${payPaymentCurrency.label} = ? INR`,
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: "Set Rate",
              inputValidator: val => {
                if (!val || isNaN(val) || Number(val) <= 0) return "Please enter a valid exchange rate."
              },
            })
            if (value) setConvertInrAmountPay(value)
            console.error("Error fetching currency rate:", error)
          }
        }
        fetchCurrencyRate()
        setIsConvertedAmountPay(true)
      } else {
        setIsConvertedAmountPay(false)
      }
    }
  }, [payPaymentCurrency, payPaymentAmount])

  const [cost, setCost] = useState(null)
  const [ExpenseOptions, setExpenseOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [quantity, setQuantity] = useState(null)
  const [introducer, setIntroducer] = useState(0)
  const [viewModal, setViewModal] = useState(false)
  const [addAdditional, setAddAdditional] = useState(false) // Modal toggle
  const [additionalInvId, setAdditionalInvId] = useState(null) // Target inventory ID (set when opening modal from table row)
  const [additionalQuantity, setAdditionalQuantity] = useState("")
  const [assigneeModal, setAssigneeModal] = useState(false)

  const [rows, setRows] = useState([{ inventoryId: null, assigneeId: null }])

  // Add a new row
  const handleAddRow = () => {
    setRows([...rows, { inventoryId: null, assigneeId: null }])
  }

  // Remove a row by index
  const handleRemoveRow = index => {
    const updated = rows.filter((_, i) => i !== index)
    setRows(updated)
  }

  // Update a row's value
  const handleChange = (index, field, value) => {
    const updated = [...rows]
    updated[index][field] = value
    setRows(updated)
  }

  // Handle submit
  const handleAssignSubmit = async () => {
    if(rows.some(row => !row.inventoryId || !row.assigneeId)) {
      Swal.fire({
        icon: "warning",
        text: "Please fill all inventory and assignee fields.",
      })
      return
    }
    const formattedData = rows.map(row => ({
      id: row.inventoryId?.value || null,
      assigned: row.assigneeId?.value || null,
    }))

    console.log("Submitted Data:", formattedData)

    const response = await FetchNodePostData(
      toggleLoading,
      "inventory/assignItems",
      secureLocalStorage.getItem("auth_token"),
      { data: formattedData }
    )
    console.log("assign: ", response)
    if (response.success || response.data.success) {
      Swal.fire({
        icon: "success",
        text: "Inventory assigned successfully!",
      })
      resetModal()
      setAssignInventory(false)
    } else {
      Swal.fire({
        icon: "error",
        text: response.message || "Failed to assign inventory.",
      })
    }
  }

  const getFilteredOptions = rowIndex => {
    const selectedIds = rows
      .filter((_, i) => i !== rowIndex)
      .map(r => r.inventoryId?.value)
      .filter(Boolean)

    return itemsOptions.filter(option => !selectedIds.includes(option.value))
  }

  const initialRow = [{ inventoryId: null, assigneeId: null }]

  const resetModal = () => {
    setRows([...initialRow])
  }

  const [assigneeLogData, setAssigneeLogData] = useState([])

  const openAssigneeModal = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      `inventory/assignedItemLogs/${assigneeitemsId}`,
      secureLocalStorage.getItem("auth_token")
    )
    console.log("Assingee Logs: ", response)
    if (response.success || response.data.success) {
      setAssigneeLogData(response.data)
      setAssigneeModal(true)
    }
  }
  const [inventoryLogDataFormatted, setInventoryLogDataFormatted] = useState([])
  useEffect(() => {
    const formattedData = inventoryLogData.map((item, index) => ({
      ...item,
      index,
    }))
    setInventoryLogDataFormatted(formattedData)
  }, [inventoryLogData])

  // Columns for Inventory Logs
  const inventoryLogColumns = useMemo(
    () => [
      {
        Header: "Sr. No",
        accessor: "index",
        Cell: ({ row }) => row.index + 1,
        className: "text-center",
      },
      {
        Header: "Inventory ID",
        accessor: "unique_code",
        className: "text-center",
      },
      {
        Header: "Total Expense",
        accessor: "inventoryInfo.totalExpense",
        Cell: ({ row }) =>
          `${row.original.inventoryInfo.currency} ${row.original.inventoryInfo.totalExpense}`,
        className: "text-center",
      },
      {
        Header: "Quantity",
        accessor: "inventoryInfo.quantity",
        className: "text-center",
      },
      {
        Header: "Purchase Date",
        accessor: "inventoryInfo.purchaseDate",
        Cell: ({ value }) => moment(value).format("DD-MM-YYYY"),
        className: "text-center",
      },
      {
        Header: "Warranty Duration",
        accessor: "inventoryInfo.warranty",
        Cell: ({ value }) => `${value} Days`,
        className: "text-center",
      },
    ],
    []
  )
  const paymentsOption = [
    {
      label: "Bank Account",
      value: "1",
    },
    {
      label: "Credit Card",
      value: "2",
    },
    {
      label: "Others",
      value: "3",
    },
  ]

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Inventory"} />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setAccessDenied={setAccessDenied}
                      setAddInventory={setAddInventory}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal  */}
      <Modal isOpen={addInventory} size="xl" className="" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Inventory</h5>
          <button
            type="button"
            onClick={() => setAddInventory(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form
            className="row d-flex flex-row justify-space-between align-items-center py-3"
            id="editCategory-box"
          >
            <div className="col-5 edit-category-img text-center">
              <img src={AddImg} alt="Add Image" />
            </div>
            <div
              className="col-7 align-self-center"
              style={{ maxHeight: "600px", overflowY: "auto" }}
            >
              <div className="col-12 d-flex flex-column justify-content-start gap-4 mb-3">
                <div className="row">
                  <div className="col-md-6">
                    <Label htmlFor="formrow-firstname-Input">
                      Category <span className="text-danger">*</span>
                    </Label>
                    <Select
                  placeholder="Select Category"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={CategoryOptions}
                  value={category}
                  onChange={selectedOption => {
                    console.log("🔹 Selected Category (raw):", selectedOption)
                    toggleLoading(true)
                    setCategory(selectedOption)

                    if (selectedOption) {
                      console.log(
                        "🧩 Filtering subcategories for categoryId:",
                        selectedOption.value
                      )
                      console.log(
                        "📦 All subcategories before filter:",
                        allSubcategoryOptions
                      )

                      const filtered = allSubcategoryOptions.filter(
                        sub => sub.categoryId === selectedOption.value
                      )

                      console.log("✅ Filtered subcategories:", filtered)
                      setSubcategoryOptions(filtered)
                    } else {
                      console.log(
                        "⚠️ Category cleared — showing all subcategories"
                      )
                      setSubcategoryOptions(allSubcategoryOptions)
                    }

                    setSubcategory(null)
                    toggleLoading(false)
                  }}
                />
                  </div>

                  <div className="col-md-6">
                    <Label htmlFor="formrow-firstname-Input">
                      Sub Category <span className="text-danger">*</span>
                    </Label>
                    <ReactSelect
                      className="basic-multi-select"
                      classNamePrefix="select"
                      id="formrow-firstname-Input"
                      placeholder="Select Sub Category"
                      options={subcategoryOptions}
                      value={subcategoryOptions.find(
                        o => o.value === subcategory
                      )}
                      onChange={opt => setSubcategory(opt ? opt.value : null)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <Label htmlFor="formrow-firstname-Input">
                      Inventory Item <span className="text-danger">*</span>
                    </Label>
                    <ReactSelect
                      className="basic-multi-select"
                      classNamePrefix="select"
                      id="formrow-firstname-Input"
                      placeholder="Select Inventory"
                      options={ItemOptions}
                      value={ItemOptions.find(o => o.value === inventItem)}
                      onChange={opt => setInventItem(opt ? opt.value : null)}
                    />
                  </div>

                  <div className="col-md-6">
                    <Label>Quantity</Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="formrow-firstname-Input"
                      placeholder="Enter Quantity"
                      value={quantity}
                      onChange={e => {
                        console.log("quantity Set: ", e)
                        setQuantity(e.target.value)
                      }}
                    />
                  </div>
                </div>

                {/* Row 1: Date of Purchase & Warranty */}
                <div className="row">
                  <div className="col-md-6">
                    <Label>Purchase Date</Label>
                    <Input
                      type="date"
                      className="form-control"
                      id="formrow-firstname-Input"
                      onChange={e => setPurchaseDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6">
                    <Label>Warranty</Label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="select"
                      id="formrow-firstname-Input"
                      placeholder="Select Warranty"
                      options={warrantyOptions || []}
                      onChange={e => {
                        setWarranty(e.value)
                      }}
                    />
                  </div>
                </div>

                <div className={`row align-items-center`}>
                  {/* Column 1: Radio Buttons */}
                  <div className="col-md-4">
                    <Label className="d-block">Expense Type</Label>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        id="new"
                        name="type"
                        value="new"
                        className="form-check-input"
                        onChange={e => setSelectedType(e.target.value)}
                      />
                      <Label htmlFor="new" className="form-check-label ms-1">
                        New
                      </Label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        id="existing"
                        name="type"
                        value="existing"
                        className="form-check-input"
                        onChange={e => setSelectedType(e.target.value)}
                      />
                      <Label
                        htmlFor="existing"
                        className="form-check-label ms-1"
                      >
                        Existing
                      </Label>
                    </div>
                  </div>

                  {/* Column 2: Conditional Select for Existing */}
                  {selectedType === "existing" && (
                    <div className="col-md-8">
                      <Label className="d-block mb-2">Select Expense</Label>
                      <Select
                        className="basic-multi-select"
                        classNamePrefix="select"
                        id="formrow-firstname-Input"
                        placeholder="Select expense"
                        styles={colourStyles}
                        options={ExpenseOptions || []}
                        value={ExpenseOptions.find(o => o.value === expense)}
                        onChange={opt => setExpense(opt ? opt.value : null)}
                      />
                    </div>
                  )}
                </div>

                {/* Conditional New Expense Form */}
                {selectedType === "new" && (
                  <div className="col-md-12 d-flex flex-column border-top pt-3">
                    <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                      <div className="col-md-6 ps-2">
                        <Label>
                          Location <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select Location"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={location}
                          value={locationValue}
                          onChange={setLocationValue}
                        />
                      </div>
                      <div className="col-md-6 ps-2">
                        <Label>
                          Currency <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select Currency"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={Currency}
                          value={currencyValue}
                          onChange={val => {
                            setCurrencyValue(val)
                            setPayPaymentCurrency(val)
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                      <div className="col-md-6 ps-2">
                        <Label>
                          Payment Via <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Payment Via"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={paymentsOption}
                          value={paymentViaValue}
                          onChange={setPaymentViaValue}
                        />
                      </div>
                      <div className="col-md-6 ps-2">
                        <Label>
                          Category <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Payment Category"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={Categories}
                          value={expenseCategoryValue}
                          onChange={setExpenseCategoryValue}
                        />
                      </div>
                    </div>

                    <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
                      <div className="col-md-12 ps-2 mb-4 row">
                        <div className="col-md-12">
                          <Label>
                            Title <span className="text-danger">*</span>
                          </Label>
                          <div className="d-flex justify-content-start align-items-center">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter Title"
                              value={titleValue}
                              onChange={e => setTitleValue(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 pb-4 ps-2 d-flex gap-2 border-bottom">
                        <div className="col-6 d-flex flex-column gap-2">
                          <div>
                            <Label>
                              Amount <span className="text-danger">*</span>
                            </Label>
                            <Input
                              required
                              type="number"
                              className="form-control"
                              placeholder="Enter Amount"
                              value={amountValue}
                              onChange={e => {
                                setAmountValue(e.target.value)
                                setPayPaymentAmount(e.target.value) // triggers conversion
                              }}
                            />
                          </div>
                          <div>
                            <Label>GST</Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter GST"
                              value={gstValue}
                              onChange={e => setGstValue(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-6 d-flex flex-column gap-2">
                          <div>
                            <Label>Exchange Rate</Label>
                            <Input
                              type="text"
                              className="form-control"
                              readOnly
                              value={convertInrAmountPay}
                              onChange={e =>
                                setConvertInrAmountPay(e.target.value)
                              }
                            />
                          </div>
                          <div>
                            <Label>Upload File</Label>
                            <input
                              className="form-control"
                              type="file"
                              onChange={e =>
                                setUploadedFile(e.target.files?.[0] ?? null)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 mb-2 pt-3">
                        <div className="d-flex align-items-center gap-3">
                          {/* Introducer Toggle */}
                          <div>
                            <Label htmlFor="introducerSwitch">Introducer</Label>
                            <div className="form-switch form-switch-md">
                              <input
                                type="checkbox"
                                className="form-check-input mt-2"
                                id="introducerSwitch"
                                checked={introducer === 1}
                                onChange={e =>
                                  setIntroducer(e.target.checked ? 1 : 0)
                                }
                              />
                            </div>
                          </div>

                          {/* Only show this section if introducer is ON */}
                          {introducer == 1 && (
                            <div className="d-flex align-items-center gap-3 flex-grow-1">
                              <div className="flex-grow-1">
                                <Label>Select Introducer</Label>
                                <Select
                                  placeholder="Select Introducer"
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  options={introducerOptions}
                                  value={introducerValue}
                                  onChange={setIntroducerValue}
                                />
                              </div>
                              <div>
                                <Label htmlFor="recordPaymentSwitch">
                                  Charge Introducer
                                </Label>
                                <div className="form-switch form-switch-md">
                                  <input
                                    type="checkbox"
                                    className="form-check-input mt-2"
                                    id="recordPaymentSwitch"
                                    checked={chargeIntroducer === 1}
                                    onChange={e =>
                                      setChargeIntroducer(
                                        e.target.checked ? 1 : 0
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-20 text-end">
              <a
                className=" btn text-white ms-md-2 btn-save btn-label"
                onClick={e => handleAddInventory(e)}
              >
                <i className="fas fa-save me-1 label-icon label-icon"></i>
                Save
              </a>

              <a
                className=" btn text-white ms-md-2 btn-red btn-label"
                onClick={() => setAddInventory(false)}
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                Cancel
              </a>
            </div>
          </Form>
        </div>
      </Modal>

      <Modal isOpen={quickInv} size="xl" className="" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Inventory</h5>
          <button
            type="button"
            onClick={() => setQuickInv(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form
            className="row d-flex flex-row justify-space-between align-items-center py-3"
            id="editCategory-box"
          >
            <div className="col-5 edit-category-img text-center">
              <img src={AddImg} alt="Add Image" />
            </div>
            <div
              className="col-7 align-self-center"
              style={{ maxHeight: "600px", overflowY: "auto" }}
            >
              <div className="col-12 d-flex flex-column justify-content-start gap-4 mb-3">
                <div className="row">
                  <div className="col-md-6">
                    <Label>Quantity</Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="formrow-firstname-Input"
                      placeholder="Enter Quantity"
                      value={quantity}
                      onChange={e => {
                        console.log("quantity Set: ", e)
                        setQuantity(e.target.value)
                      }}
                    />
                  </div>
                </div>

                {/* Row 1: Date of Purchase & Warranty */}
                <div className="row">
                  <div className="col-md-6">
                    <Label>Purchase Date</Label>
                    <Input
                      type="date"
                      className="form-control"
                      id="formrow-firstname-Input"
                      onChange={e => setPurchaseDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6">
                    <Label>Warranty</Label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="select"
                      id="formrow-firstname-Input"
                      placeholder="Select Warranty"
                      options={warrantyOptions || []}
                      onChange={e => {
                        setWarranty(e.value)
                      }}
                    />
                  </div>
                </div>

                <div className={`row align-items-center`}>
                  {/* Column 1: Radio Buttons */}
                  <div className="col-md-4">
                    <Label className="d-block">Expense Type</Label>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        id="new"
                        name="type"
                        value="new"
                        className="form-check-input"
                        onChange={e => setSelectedType(e.target.value)}
                      />
                      <Label htmlFor="new" className="form-check-label ms-1">
                        New
                      </Label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        id="existing"
                        name="type"
                        value="existing"
                        className="form-check-input"
                        onChange={e => setSelectedType(e.target.value)}
                      />
                      <Label
                        htmlFor="existing"
                        className="form-check-label ms-1"
                      >
                        Existing
                      </Label>
                    </div>
                  </div>

                  {/* Column 2: Conditional Select for Existing */}
                  {selectedType === "existing" && (
                    <div className="col-md-8">
                      <Label className="d-block mb-2">Select Expense</Label>
                      <Select
                        className="basic-multi-select"
                        classNamePrefix="select"
                        id="formrow-firstname-Input"
                        placeholder="Select expense"
                        styles={colourStyles}
                        options={ExpenseOptions || []}
                        value={ExpenseOptions.find(o => o.value === expense)}
                        onChange={opt => setExpense(opt ? opt.value : null)}
                      />
                    </div>
                  )}
                </div>

                {/* Conditional New Expense Form */}
                {selectedType === "new" && (
                  <div className="col-md-12 d-flex flex-column border-top pt-3">
                    <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                      <div className="col-md-6 ps-2">
                        <Label>
                          Location <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select Location"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={location}
                          value={locationValue}
                          onChange={setLocationValue}
                        />
                      </div>
                      <div className="col-md-6 ps-2">
                        <Label>
                          Currency <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select Currency"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={Currency}
                          value={currencyValue}
                          onChange={val => {
                            setCurrencyValue(val)
                            setPayPaymentCurrency(val)
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                      <div className="col-md-6 ps-2">
                        <Label>
                          Payment Via <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Payment Via"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={paymentsOption}
                          value={paymentViaValue}
                          onChange={setPaymentViaValue}
                        />
                      </div>
                      <div className="col-md-6 ps-2">
                        <Label>
                          Category <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Payment Category"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={Categories}
                          value={expenseCategoryValue}
                          onChange={setExpenseCategoryValue}
                        />
                      </div>
                    </div>

                    <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
                      <div className="col-md-12 ps-2 mb-4 row">
                        <div className="col-md-12">
                          <Label>
                            Title <span className="text-danger">*</span>
                          </Label>
                          <div className="d-flex justify-content-start align-items-center">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter Title"
                              value={titleValue}
                              onChange={e => setTitleValue(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 pb-4 ps-2 d-flex gap-2 border-bottom">
                        <div className="col-6 d-flex flex-column gap-2">
                          <div>
                            <Label>
                              Amount <span className="text-danger">*</span>
                            </Label>
                            <Input
                              required
                              type="number"
                              className="form-control"
                              placeholder="Enter Amount"
                              value={amountValue}
                              onChange={e => {
                                setAmountValue(e.target.value)
                                setPayPaymentAmount(e.target.value) // triggers conversion
                              }}
                            />
                          </div>
                          <div>
                            <Label>GST</Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter GST"
                              value={gstValue}
                              onChange={e => setGstValue(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-6 d-flex flex-column gap-2">
                          <div>
                            <Label>Exchange Rate</Label>
                            <Input
                              type="text"
                              className="form-control"
                              readOnly
                              value={convertInrAmountPay}
                              onChange={e =>
                                setConvertInrAmountPay(e.target.value)
                              }
                            />
                          </div>
                          <div>
                            <Label>Upload File</Label>
                            <input
                              className="form-control"
                              type="file"
                              onChange={e =>
                                setUploadedFile(e.target.files?.[0] ?? null)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 mb-2 pt-3">
                        <div className="d-flex align-items-center gap-3">
                          {/* Introducer Toggle */}
                          <div>
                            <Label htmlFor="introducerSwitch">Introducer</Label>
                            <div className="form-switch form-switch-md">
                              <input
                                type="checkbox"
                                className="form-check-input mt-2"
                                id="introducerSwitch"
                                checked={introducer === 1}
                                onChange={e =>
                                  setIntroducer(e.target.checked ? 1 : 0)
                                }
                              />
                            </div>
                          </div>

                          {/* Only show this section if introducer is ON */}
                          {introducer == 1 && (
                            <div className="d-flex align-items-center gap-3 flex-grow-1">
                              <div className="flex-grow-1">
                                <Label>Select Introducer</Label>
                                <Select
                                  placeholder="Select Introducer"
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  options={introducerOptions}
                                  value={introducerValue}
                                  onChange={setIntroducerValue}
                                />
                              </div>
                              <div>
                                <Label htmlFor="recordPaymentSwitch">
                                  Charge Introducer
                                </Label>
                                <div className="form-switch form-switch-md">
                                  <input
                                    type="checkbox"
                                    className="form-check-input mt-2"
                                    id="recordPaymentSwitch"
                                    checked={chargeIntroducer === 1}
                                    onChange={e =>
                                      setChargeIntroducer(
                                        e.target.checked ? 1 : 0
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-20 text-end">
              <a
                className=" btn text-white ms-md-2 btn-save btn-label"
                onClick={e => handleAdditionalInventory(e)}
              >
                <i className="fas fa-save me-1 label-icon label-icon"></i>
                Save
              </a>

              <a
                className=" btn text-white ms-md-2 btn-red btn-label"
                onClick={() => setAddInventory(false)}
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                Cancel
              </a>
            </div>
          </Form>
        </div>
      </Modal>

      {/* View Modal  */}
      <Modal isOpen={inveIdPopup} size="md" className="" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Inventory Details</h5>
          <button
            type="button"
            onClick={() => setInveIdPopup(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form
            className="row d-flex flex-column justify-content-center align-items-center py-3"
            id="editCategory-box"
          >
            <div className="col-12 edit-category-img text-center">
              <img src={warningImg} alt="View Image" />
            </div>
            <div className="col-12 align-self-center">
              <h6 className="text-danger mb-3">
                This Inventory Item is Already Assigned to Following Member.
              </h6>
              <div className="col-12 d-flex justify-content-start align-items-center gap-3">
                <div className="col-4 mb-3">
                  <Label>Inventory ID</Label>
                  <Input
                    disabled
                    type="text"
                    className="form-control"
                    id="formrow-firstname-Input"
                    placeholder="Inventory ID"
                    value="Mu-11245"
                  />
                </div>
                <div className="col-7 mb-3">
                  <Label>Assignee</Label>
                  <Input
                    disabled
                    type="text"
                    className="form-control"
                    id="formrow-firstname-Input"
                    placeholder="Inventory ID"
                    value="Rahul Ovhal"
                  />
                </div>
              </div>
            </div>
            <div className="mt-2 text-center">
              <a
                className=" btn text-white btn-success "
                onClick={() => setInveIdPopup(false)}
              >
                Okay
              </a>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Assignee Modal  */}
      <Modal isOpen={assignInventory} size="xl" centered>
        <div className="modal-header">
          <div className="d-flex align-items-center gap-2">
            <h5 className="modal-title mt-0 mb-0">Assign Inventory</h5>
            <button
              type="button"
              className="bi bi-pc-display btn btn-light p-1"
              onClick={() => {
                openAssigneeModal()
              }}
            ></button>
          </div>
          <button
            type="button"
            onClick={() => {
              resetModal()
              setAssignInventory(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body">
          <Form className="row d-flex flex-row justify-space-between align-items-center py-3">
            <div className="col-md-5 edit-category-img text-center">
              <img
                src={AssignImg}
                alt="View Image"
                style={{ maxWidth: "500px" }}
              />
            </div>

            <div className="col-md-7 align-self-center ps-3">
              {/* Summary Info */}
              <div className="col-12 d-flex justify-content-start align-items-center gap-1 mb-4">
                <div className="col-4">
                  <h6 className="text-purple">Inventory Item</h6>
                  <h5 className="text-primary">{inventoryItem}</h5>
                </div>
                <div className="col-4">
                  <h6 className="text-purple">Total Quantity</h6>
                  <h5 className="text-primary">{inventoryQuantity}</h5>
                </div>
                {/* <div className="col-3">
                  <h6 className="text-purple">Assign Quantity</h6>
                  <h5 className="text-primary">{rows.length}</h5>
                </div> */}
                <div className="col-4">
                  <h6 className="text-purple">Last Purchase Date</h6>
                  <h5 className="text-primary">
                    {inventoryPurchaseDate
                      ? moment(inventoryPurchaseDate).format("DD-MM-YYYY")
                      : "-"}
                  </h5>
                </div>
              </div>

              {/* Dynamic Input Rows */}
              {rows.map((row, index) => (
                <div key={index} className="col-12 d-flex gap-3 mb-3">
                  <div className="col-4">
                    <Label>Inventory ID</Label>
                    <ReactSelect
                      placeholder="Select Option"
                      classNamePrefix="select"
                      options={getFilteredOptions(index)}
                      value={row.inventoryId}
                      onChange={value =>
                        handleChange(index, "inventoryId", value)
                      }
                    />
                  </div>

                  <div className="col-7">
                    <Label>
                      Assignee <span className="text-danger">*</span>
                    </Label>
                    <ReactSelect
                      placeholder="Select Assignee"
                      classNamePrefix="select"
                      options={allStaffDatas}
                      value={row.assigneeId}
                      onChange={value =>
                        handleChange(index, "assigneeId", value)
                      }
                    />
                  </div>

                  {rows.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm mt-4"
                      onClick={() => handleRemoveRow(index)}
                    >
                      <i className="dripicons-cross"></i>
                    </button>
                  )}
                </div>
              ))}

              {/* Add More Button */}
              <div className="text-start mb-3">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={handleAddRow}
                >
                  + Add Another
                </button>
              </div>
            </div>

            {/* Submit + Cancel */}
            <div className="mt-20 text-end">
              <button
                type="button"
                onClick={handleAssignSubmit}
                className="btn text-white ms-md-2 btn-save btn-label"
              >
                <i className="fas fa-save me-1 label-icon"></i> Submit
              </button>

              <button
                type="button"
                className="btn text-white ms-md-2 btn-red btn-label"
                onClick={() => {
                  resetModal()
                  setAssignInventory(false)
                }}
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                Cancel
              </button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Delete Modal  */}
      <Modal isOpen={deletePopup} size="xl" className="" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Delete Inventory</h5>
          <button
            type="button"
            onClick={() => setDeletePopup(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form
            className="row d-flex flex-row justify-space-between align-items-center py-3"
            id="editCategory-box"
          >
            <div className="col-md-5 edit-category-img text-center">
              <img src={AssignImg} alt="View Image" />
            </div>
            <div className="col-md-7 align-self-center ps-3">
              <div className="col-12 d-flex justify-content-start align-items-center gap-1 mb-4">
                <div className="col-3">
                  <h6 className="text-purple">Inventory Item</h6>
                  <h5 className="text-primary">Mouse</h5>
                </div>
                <div className="col-3">
                  <h6 className="text-purple">Total Quantity</h6>
                  <h5 className="text-primary">50</h5>
                </div>
                <div className="col-3">
                  <h6 className="text-purple">Assign Quantity</h6>
                  <h5 className="text-primary">30</h5>
                </div>
                <div className="col-3">
                  <h6 className="text-purple">Last Purchase Date</h6>
                  <h5 className="text-primary">20/08/2024</h5>
                </div>
              </div>

              <div className="col-12 d-flex justify-content-start align-items-center gap-3">
                <div className="col-3 mb-3">
                  <Label>Inventory ID</Label>
                  <ReactSelect
                    placeholder="Select Option"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={inventoryIdOptions}
                    onChange={handleSelectChange}
                  />
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Discard Popup  */}
      <div
        className={`note-sticky-form ${discardPopup ? "d-block" : "d-none"}`}
      >
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "25%",
              left: "45%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0 mb-3">Discard Item</h5>
            </div>

            <div className="modal-body pe-4">
              <Form className="row d-flex justify-content-center align-items-center">
                <div className="col-md-12 d-flex flex-column justify-content-center  gap-3">
                  <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                    <div className="col-12 mb-3">
                      <label htmlFor="">
                        Upload Photo <span className="text-danger">*</span>
                      </label>
                      <Input
                        type="file"
                        className="form-control"
                        id="formrow-firstname-Input"
                        placeholder="Enter Reason"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="">
                        Reason <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows="5"
                        cols="20"
                      ></textarea>
                    </div>
                  </div>
                  <div className="text-end mt-2">
                    <button className=" btn btn-save btn-label">
                      <i className="fas fa-save me-2 label-icon"></i>
                      Save
                    </button>
                    <a
                      onClick={() => {
                        setDiscardPopup(false)
                      }}
                      className=" btn ms-md-2 btn-red btn-label"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>
                      CANCEL
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      {/* Warranty Popup  */}
      <div
        className={`note-sticky-form ${warrantyPopup ? "d-block" : "d-none"}`}
      >
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "35%",
              left: "45%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0 mb-3">Warranty Info</h5>
            </div>

            <div className="modal-body pe-4">
              <Form className="row d-flex justify-content-start align-items-center">
                <div className="col-md-12 d-flex flex-column justify-content-start  gap-3">
                  <div className="col-12 d-flex flex-column justify-content-start align-items-start">
                    <div className="col-6 mb-3">
                      <label htmlFor="">
                        Date <span className="text-danger">*</span>
                      </label>
                      <Input
                        type="date"
                        className="form-control"
                        id="formrow-firstname-Input"
                        placeholder="date"
                        required
                      />
                    </div>
                  </div>
                  <div className="text-end mt-2">
                    <button className=" btn btn-save btn-label">
                      <i className="fas fa-save me-2 label-icon"></i>
                      Save
                    </button>
                    <a
                      onClick={() => {
                        setWarrantyPopup(false)
                      }}
                      className=" btn ms-md-2 btn-red btn-label"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>
                      CANCEL
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      {/* Repair Popup  */}
      <div className={`note-sticky-form ${repairPopup ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "35%",
              left: "45%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0 mb-3">Repair Info</h5>
            </div>

            <div className="modal-body pe-4">
              <Form className="row d-flex justify-content-start align-items-center">
                <div className="col-md-12 d-flex flex-column justify-content-start  gap-3">
                  <div className="col-12 d-flex flex-column justify-content-start align-items-start">
                    <div className="col-6 mb-3">
                      <label htmlFor="">
                        Date <span className="text-danger">*</span>
                      </label>
                      <Input
                        type="date"
                        className="form-control"
                        id="formrow-firstname-Input"
                        placeholder="date"
                        required
                      />
                    </div>
                  </div>
                  <div className="text-end mt-2">
                    <button className=" btn btn-save btn-label">
                      <i className="fas fa-save me-2 label-icon"></i>
                      Save
                    </button>
                    <a
                      onClick={() => {
                        setRepairPopup(false)
                      }}
                      className=" btn ms-md-2 btn-red btn-label"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>
                      CANCEL
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      <ModalTable
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        data={inventoryLogDataFormatted}
        columns={inventoryLogColumns}
        title="Inventory Logs"
      />

      <Modal
        isOpen={assigneeModal}
        toggle={() => setAssigneeModal(false)}
        size="lg"
        centered
        style={{ maxHeight: "95vw", width: "95vw" }}
      >
        <ModalHeader
          toggle={() => {
            setAssigneeModal(false)
          }}
          className="text-purple"
        >
          Inventory Item Assignees <span className="text-primary fw-bold"></span>
        </ModalHeader>
        <ModalBody>
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th className="text-center">Sr. No</th>
                <th className="text-center">Unique Code</th>
                <th className="text-center">Assignee</th>
              </tr>
            </thead>
            <tbody>
              {assigneeLogData.length > 0 ? (
                assigneeLogData.map((item, index) => (
                  <tr key={item.id}>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{item?.unique_code}</td>
                    <td className="text-center">
                      {item?.assignedUserInfo?.alias_name}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="text-center">
                  <td colSpan={6}>No Inventory Logs Found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default Inventory
